import { render, staticRenderFns } from "./PlainRouterView.vue?vue&type=template&id=2b59a104"
import script from "./PlainRouterView.vue?vue&type=script&lang=js"
export * from "./PlainRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports